const indexItems = [
  { title: '娱乐圈·明星八卦', desc: '明星恋情、婚变、私生活、片场路透...娱乐圈最新最全八卦合集', count: '1,286篇', icon: 'ri-star-fill' },
  { title: '网红圈·直播黑料', desc: '网红翻车、带货造假、美颜滤镜失灵、MCN机构内幕全记录', count: '964篇', icon: 'ri-live-fill' },
  { title: '社会热点·吃瓜视角', desc: '从吃瓜角度看社会热点事件，不一样的新闻解读', count: '752篇', icon: 'ri-fire-fill' },
  { title: '影视综·内幕追踪', desc: '电影电视剧综艺节目的幕后故事、选角内幕、片酬揭秘', count: '631篇', icon: 'ri-film-fill' },
  { title: '时尚圈·红毯翻车', desc: '明星穿搭点评、红毯翻车现场、整容前后对比全收录', count: '518篇', icon: 'ri-t-shirt-fill' },
  { title: '体育圈·场外风云', desc: '运动员场外八卦、转会内幕、代言风波一手掌握', count: '403篇', icon: 'ri-football-fill' },
  { title: '音乐圈·歌坛秘闻', desc: '歌手私生活、演唱会内幕、音乐版权纠纷深度追踪', count: '387篇', icon: 'ri-music-fill' },
  { title: '商业圈·大佬八卦', desc: '企业家私生活、公司内斗、资本博弈背后的不为人知', count: '295篇', icon: 'ri-briefcase-fill' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-2">专题合集</h2>
        <p className="text-foreground-500 text-sm text-center mb-8">按类别浏览，找到你最感兴趣的吃瓜内容</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#index"
              className="group bg-background-100 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center mb-3 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-lg text-primary-500`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 whitespace-nowrap overflow-hidden text-ellipsis">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">{item.desc}</p>
              <span className="text-[11px] text-primary-500 font-medium">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}